import React from "react";
import { Link } from "react-router-dom";
import get from "lodash/get";

import { Col, Row, Layout } from "antd";
import settingsIcon from "../../assets/img/settings.png";

import styles from "./Footer.css";
import { connect } from "react-redux";
import { getTheme } from "../../reducers/theme/selectors";

const Footer = (props) => {
  return (
    <Layout.Footer className={styles.footer}>
      <Row type="flex" align="middle" justify="center">
        <Col md={12} sm={24}>
          <Row>
            <Col lg={24}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/*{props.theme.logo_dark && (
                  <img
                    alt="diamind"
                    src={props.theme.logo_dark}
                    style={{
                      objectFit: "contain",
                      height: "43px",
                      width: "auto",
                      marginTop: 20,
                      marginLeft: 40,
                    }}
                  />
                )}*/}

                <a
                  href="https://www.diamindsolutions.ca"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="/diamind.png"
                    alt="Diamind"
                    width={150}
                    style={{ margin: "20px 0 0 20px" }}
                  />
                </a>
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={12} sm={24}>
          <span style={{ float: "right" }}>
            © {new Date().getFullYear()} | All rights reserved! |
            <a
              href="https://www.diamindsolutions.ca"
              target="_blank"
              rel="noopener"
            >
              {" "}
              Diamind Solutions Inc.{" "}
            </a>
          </span>

        </Col>
      </Row>
        {get(props, 'isAuthenticated') && (
        <Row type="flex" align="middle" justify="center">
          <Col sm={24}>

              <span style={{ float: "right", 'lineHeight': '10px' }}>
                {get(props, 'feVersion') &&
                  <p style={{color: "gray", fontWeight:"lighter", fontSize: "10px", marginBottom:"2px"}}>UI version: {get(props, 'feVersion')}</p>
                }
                {get(props, 'apiVersion') &&
                  <p style={{color: "gray", fontWeight:"lighter", fontSize: "10px", marginBottom:"2px"}}>API version: {get(props, 'apiVersion')}</p>
                }
              </span>

          </Col>
        </Row>
          )}

      {!props.noAdminLink && (
        <Link to="/admin/dashboard" className={styles.settingsLink}>
          <img
            alt="admin"
            src={settingsIcon}
            style={{ width: "28px", height: "28px" }}
          />
        </Link>
      )}
    </Layout.Footer>
  );
};

export default connect((state) => ({
  theme: getTheme(state),
}))(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js